import SearchList from '../../antd/Lists/SearchList'

const SectorsList = ({ bordered, sectors = [], selected, maxHeight, onSelectedChange }) => {
  const options = sectors.map(sector => ({
    label: sector.name,
    value: sector.id,
    tooltip: sector.name
  }))

  return (
    <div className='h-100'>
      <SearchList
        selected={selected}
        data={options}
        maxHeight={maxHeight}
        onSelectedChange={onSelectedChange}
      />
    </div>
  )
}

export default SectorsList
